import { useContext } from 'react';
import { AsyncValidationFormContext } from '../asyncValidationFormContext';
import { AsyncValidationFormContextState } from '../interfaces/async-validation-form';

export const useAsyncValidationForm = <
  T extends object = object
>(): AsyncValidationFormContextState<T> => {
  return useContext(AsyncValidationFormContext) as AsyncValidationFormContextState<T>;
};
